/* eslint-disable react-hooks/exhaustive-deps */
import s from "./styles";
import React, { useCallback, useMemo, useState } from "react";
import PieChartTaxes from "components/InformTaxesReport/PieChartTaxes";
import TopWidgetInformation from "components/common/TopWidgetInformation";
import List from "components/common/ListWidget";
import moment from "moment";
import { toPng } from "html-to-image";
import { useBusinessContext } from "BusinessApp";
import { utils, writeFile } from "xlsx";
import { useOrderTaxSummary } from "graphql/useOrderSummary";

import BagIcon from "components/icons/BagIcon";

import Bill from "components/icons/Bill";
import Moneybag from "components/icons/Moneybag";
import "../../index.css";
import { useTranslation } from "react-i18next";
import TopMenu from "components/Reports/TopMenu";
import { getDateHeader } from "helpers/dataHelper";
import DocumentPDF from "./DocumentPDF";
import { printDocumentPDF } from "helpers/utils";

function ReportsTaxes() {
  const { t } = useTranslation();
  const { storeId, currencyFormat } = useBusinessContext();
  const [date, setDate] = useState({
    value: moment(),
    periodType: "date",
    range: { start: moment().startOf("day"), end: moment().endOf("day") },
  });

  const firstGraph = React.useRef(null);

  // TODO: PCP-1859
  const { data, loading } = useOrderTaxSummary(storeId, date.range);
  const { orderTaxes } = data;

  const allDate = `${
    date.periodType === "date"
      ? t("containers.ReportsTaxes.allday")
      : date.periodType === "week"
      ? t("containers.ReportsTaxes.allWeek")
      : date.periodType === "month"
      ? t("containers.ReportsTaxes.allMonth")
      : t("containers.ReportsTaxes.allYear")
  }`;

  const [sorting, setSorting] = useState({ columnId: "earnings", order: 1 });

  const { tableValues, tableExcel, total, totalBaseImp, totalImp } =
    useMemo(() => {
      const tableValues = orderTaxes.map((v) => [
        v?.name,
        ` ${v?.name.match(/(\d+)/g) === null ? "0" : v?.name.match(/(\d+)/g)}%`,
        currencyFormat(v.total2),
        currencyFormat(v.total),
      ]);

      const tableExcel = orderTaxes.map((v) => [
        v?.name,
        ` ${v?.name.match(/(\d+)/g) === null ? "0" : v?.name.match(/(\d+)/g)}%`,
        parseFloat(v.total2),
        parseFloat(v.total),
      ]);

      const data = orderTaxes.map((v) => ({
        name: v.name,
        count: v.total3,
        quantity: v.quantity.toFixed(2),
        quantity2: v.quantity2.toFixed(2),
        quantity3: v.quantity3.toFixed(2),
        total: v.total.toFixed(2),
        total2: v.total2.toFixed(2),
        total3: v.total3.toFixed(2),
      }));

      const total = data
        .reduce((a, b) => parseFloat(a) + parseFloat(b.total3), 0)
        .toFixed(2);
      const totalBaseImp = data
        .reduce((a, b) => parseFloat(a) + parseFloat(b.total2), 0)
        .toFixed(2);
      const totalImp = data.reduce(
        (a, b) => parseFloat(a) + parseFloat(b.total),
        0
      );
      tableValues.push([t("general.total"), "", "", currencyFormat(totalImp)]);
      return {
        tableValues,
        tableExcel,
        total,
        totalBaseImp,
        totalImp,
      };
    }, [orderTaxes]);

  const exportFileExcel = useCallback(() => {
    const worksheetData = [
      [
        t("containers.ReportsTaxes.tax"),
        t("containers.ReportsTaxes.rate"),
        t("containers.ReportsTaxes.taxBase"),
        t("containers.ReportsTaxes.taxesCollected"),
      ],
    ];
    tableExcel.map((item) => {
      worksheetData.push(item);
    });

    const workbook = utils.book_new();
    const sheetName = t("containers.ReportsTaxes.ReportsTaxes");
    const worksheet = utils.aoa_to_sheet(worksheetData);
    utils.book_append_sheet(workbook, worksheet, sheetName);

    writeFile(workbook, `${t("containers.ReportsTaxes.ReportsTaxes")}.xlsx`);
  }, [
    date.range.end,
    date.range.start,
    orderTaxes,
    tableExcel,
    total,
    totalBaseImp,
    totalImp,
  ]);

  const getImageGraph = useCallback(async () => {
    const img1 = await toPng(firstGraph.current, { cacheBust: true });

    await printDocumentPDF(
      <DocumentPDF
        data={{
          dateHeader: getDateHeader(date.range.start, date.range.end)[0],
          header: {
            total: currencyFormat(total),
            totalBaseImp: currencyFormat(totalBaseImp),
            totalImp: currencyFormat(totalImp),
          },
          tableValues,
          dataStart: moment(date.range.start).format("MMMM"),
          img1,
        }}
      />,
      `${t("containers.ReportsTaxes.ReportsTaxes")}.pdf`
    );
  }, [
    date.range.end,
    date.range.start,
    tableValues,
    total,
    totalBaseImp,
    totalImp,
  ]);

  return (
    <s.PageContainer>
      <TopMenu
        loading={loading}
        value={date.value}
        onChange={(value, periodType, range) => {
          setDate({ value, periodType, range });
        }}
        exportFileExcel={exportFileExcel}
        getImageGraph={getImageGraph}
        disabled={orderTaxes.length === 0}
      />

      <TopWidgetInformation
        elements={[
          {
            value: currencyFormat(total) || "-",
            text: t("containers.ReportsTaxes.totalItemsSales"),
            icon: <BagIcon />,
          },
          {
            value: currencyFormat(totalBaseImp) || "-",
            text: t("containers.ReportsTaxes.taxBase"),
            icon: <Bill />,
          },
          {
            value: currencyFormat(totalImp) || "-",
            text: t("containers.ReportsTaxes.totalRaised"),
            icon: <Moneybag />,
          },
        ]}
      />
      <s.Container
        style={{
          display: "flex",
          gap: "20px",
        }}
      >
        <s.ChartComponentsWrapper>
          <PieChartTaxes
            orderTaxes={orderTaxes}
            loading={loading}
            firstGraph={firstGraph}
          />
        </s.ChartComponentsWrapper>
        <div style={{ width: "100%", height: "259" }}>
          <List
            width="720px"
            items={tableValues}
            title={`${date.range.start
              .toDate()
              .toLocaleString("es-Es", { month: "long" })
              .replace(/\b\w/g, (l) => l.toUpperCase())} ${date.range.start
              .toDate()
              .getFullYear()}`}
            allDate={allDate}
            columns={[
              {
                title: t("containers.ReportsTaxes.tax"),
              },
              {
                title: t("containers.ReportsTaxes.rate"),
              },
              {
                title: t("containers.ReportsTaxes.taxBase"),
              },
              {
                title: t("containers.ReportsTaxes.taxesCollected"),
              },
            ]}
            tableStyle={{ gridTemplateColumns: "26fr 21fr 19fr 17fr " }}
            sorting={sorting}
            changeSorting={(columnId, order) => setSorting({ columnId, order })}
            loading={loading}
          />
        </div>
      </s.Container>
    </s.PageContainer>
  );
}

export default ReportsTaxes;
